export enum PublicationItemStatus {
    Unknown = 0,
    Active = 1,
    NotShared = 2,
    NotStarted = 3,
    Ended = 4,
}
